import { CdnAsset } from "#components/ui/CdnAsset.tsx";
import { getCitationSourceApp, joinSourceMeta, useCitationSourceLabels } from "#features/conversations/components/conversation-source/citationSource.tsx";
import type { ConversationSource } from "#types/types.ts";
import { useColorSchemeValue } from "@hopper-ui/components";
import classNames from "classnames";
import type { ReactElement } from "react";
import "#css/ink.css";
import "./SourcePreview.css";

interface Props {
    source: ConversationSource;
    date: string | null;
    /** Replaces the app's name (a web page names its site). */
    appName?: string | null;
    /** Replaces the app's colour tile (a web page shows its favicon). */
    tile?: ReactElement;
}

/** The hover card's first line: the app's colour tile, its name, then "Type · Date". */
export const SourcePreviewHeader = ({ source, date, appName, tile }: Props) => {
    const { channel, isKnownApp, glyph } = getCitationSourceApp(source);
    const labels = useCitationSourceLabels(source);
    // The tile sits on the card with no plate behind it. See ConnectorChannelIcon.
    const tileUrl = useColorSchemeValue(channel.iconUrl, channel.iconUrlDark ?? channel.iconUrl);
    const isNeutral = !tile && !isKnownApp;

    return (
        <div className="wai-source-card-header">
            <span aria-hidden="true" className={classNames("wai-source-card-tile", { "wai-source-card-tile--neutral": isNeutral })}>
                {tile ?? (isNeutral ? glyph : <CdnAsset asset={tileUrl} alt="" />)}
            </span>
            {(appName || labels.appName) && <span className="wai-source-card-app">{appName || labels.appName}</span>}
            <span className="wai-source-card-meta">{joinSourceMeta(labels.typeLabel, date)}</span>
        </div>
    );
};
